<template>
  <div>
      <ContentHeader path-set-type="append" :gameplan-nav="false"  />
      <div class="content-wrapper" v-loading="loading">
          <el-row>
              <el-col :span="24" class="content-right" >
                  <div class="search">
                      <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                      <el-form-item class="item selcetItem" prop="themeId" style="width:150px">
                          <el-select v-model="searchForm.themeId" :popper-append-to-body="false" placeholder="选择活动主题" filterable clearable size="small">
                              <el-option
                              v-for="item in themeList"
                              :key="item.themeId"
                              :label="item.themeName"
                              :value="item.themeId">
                              </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="item" prop="blockName">
                          <el-input v-model="searchForm.blockName" placeholder="街区名称" size="small" clearable></el-input>
                      </el-form-item>
                      <el-form-item class="item" prop="pocName">
                          <el-input v-model="searchForm.pocName" placeholder="门店名称" size="small" clearable></el-input>
                      </el-form-item>
                      <!-- <el-form-item class="item" prop="selectBrand">
                          <el-select v-model="searchForm.selectBrand" placeholder="选择品牌" size="small" clearable>
                              <el-option
                              v-for="item in brandOptions"
                              :key="item.brandId"
                              :label="item.brandName"
                              :value="item.abiBrandCode">
                              </el-option>
                          </el-select>
                      </el-form-item> -->
                      <el-form-item class="item" prop="selectChannel">
                          <el-select v-model="searchForm.selectChannel" placeholder="选择渠道" size="small" clearable>
                              <el-option
                              v-for="item in channelOptions"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key">
                              </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="item" prop="selectType">
                          <el-select v-model="searchForm.selectType" placeholder="选择形式" size="small" clearable>
                              <el-option
                              v-for="(key,value) in typeOptions"
                              :key="value"
                              :label="key"
                              :value="value">
                              </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="item" prop="selectLevel">
                          <el-select v-model="searchForm.selectLevel" placeholder="选择级别" size="small" clearable>
                              <el-option
                              v-for="(key,value) in levelOptions"
                              :key="value"
                              :label="key"
                              :value="value">
                              </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="item" prop="buCode" v-if="isHQ">
                          <el-select v-model="searchForm.buCode" placeholder="选择BU" filterable  size="small" clearable @change="cahngeBu()">
                              <el-option
                              v-for="item in buArr"
                              :key="item.orgCode"
                              :label="item.orgName"
                              :value="item.orgCode">
                              </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="item" style="width:170px" prop="regionCode">
                          <el-select v-model="searchForm.regionCode" placeholder="选择销售大区" filterable  size="small" clearable>
                              <el-option
                              v-for="item in regionArr"
                              :key="item.orgCode"
                              :label="item.orgName"
                              :value="item.orgCode">
                              </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="item-btn">
                          <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                      </el-form-item>
                      <el-form-item>
                          <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                      </el-form-item>
                      </el-form>
                  </div>
                  <div class="card-box" >
                      <div class="card is-hover-shadow" v-for="(item) in cardData" :key="item.activityId" >
                      <div class="left">
                          <div class="left-top">
                              <div class="top-name">
                                  <span v-if="item.blockName">{{item.blockName}}</span>
                                  <span v-else>{{item.gpActivityPocDTOList[0].pocName}}</span>
                                  <span style="margin-left: 5px;" v-if="item.blockName && item.gpActivityPocDTOList">：
                                      <span>{{getToolsname(item,'saleName','、')}}</span>
                                  </span>
                              </div>
                              <div class="top-sign" v-if="item.themeInfoDTO">{{getBluename(item.themeInfoDTO.orgLevel)}}</div>
                          </div>
                          <div class="left-second">
                              <div class="second-left">{{getToolsname(item,'activityName','-')}}</div>
                              <div class="second-right">
                                  <span  class="font-weight-bold">已提报:</span>
                                  <span style="margin-left: 5px;">{{item.submitCountQty}}场</span>
                              </div>
                          </div>
                          <div class="left-third">
                              <span  class="font-weight-bold">活动时间：</span>
                              <span>{{getTime(item.beginTime)}}</span>
                              <span style="margin: 0px 5px;">-</span>
                              <span>{{getTime(item.endTime)}}</span>
                          </div>
                          <div class="left-last">
                              <span  class="font-weight-bold">区域：</span>
                              <span>{{getToolsname(item,'areaName','-')}}</span>
                              <span  class="font-weight-bold" style="margin-left: 25px;">提报售点要求：</span>
                              <span>{{getToolsname(item,'typeName')}}</span>
                          </div>
                      </div>
                      <div class="right">
                          <div class="right-top">
                              <span>已退回</span>
                          </div>
                          <div class=" operation_btn_box">
                            <div class="operate_btn btn-left" @click="activityDetail(item)">查看详情</div>
                            <div class="operate_btn btn-left" v-if="isRegion" @click="handleDelete(item)">删除</div>
                            <div class="operate_btn btn-right" v-if="isRegion" @click="gotoReportAgain(item)">重新提报</div>
                          </div>
                      </div>
                  </div>
                  </div>
                  <div v-if="cardData.length == 0">
                      <!-- style="height:50vh; line-height:50vh;text-align: center;" -->
                      <el-empty description="暂无数据"></el-empty>
                  </div>
                  <div class="pagination" v-if="cardData.length > 0">
                      <el-pagination
                      background
                      layout="total, prev, pager, next"
                      :total="searchForm.total"
                      :current-page="searchForm.page"
                      :page-size="searchForm.pageSize"
                      @current-change="handleCurrentChange"
                      />
                  </div>
              </el-col>
          </el-row>
      </div>
  </div>
</template>
<script>
  import { mapGetters,mapState } from 'vuex'
  import ContentHeader from '@/components/content-header'
  import gameplanApi from '../../api/gameplan'
  export default {
    name: 'activity-report-return',
    components: {
      ContentHeader,
    },
    data () {
      return {
          searchForm: {
              themeId:'',
              prId: '', // PR编码
              prName: '', // PR名称
              blockName:'', // 街区名称
              pocName:'',// 售点名称
              activityName: '', // 活动名称
              selectBrand: '' , // 选择品牌
              selectChannel: '', // 选择渠道
              searchStatus: '',
              page: 1,
              pageSize: 10,
              total:0,
              selectType: '', //形式
              selectLevel: '', //级别
              buCode:'',
              regionCode:'',
              buOrgId:''
          },
          channelOptions: [], // 渠道下拉菜单
          brandOptions: [], // 品牌下拉菜单
          typeOptions:[],
          levelOptions:[],
          cardData: [],
          loading: true,
          menuCode: '1000',
          menuMap:[
              {key:'01',value:"待提报"},
              {key:'04',value:"审批中"},
              {key:'02',value:"执行中"},
              {key:'03',value:"已退回"},
              {key:'09',value:"已完成"},
          ],
          themeList:[],
          buArr:[],
          regionArr: [],
          employeeLevel:''
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      ...mapState({
        regionOrgList: state => state.gameplan.regionOrgList
      }),
      isHQ(){
        return this.employeeLevel>=90
      },
      isBU(){
        return this.employeeLevel>=60&&this.employeeLevel<90
      },
      isRegion(){
        return this.employeeLevel>=45&&this.employeeLevel<60
      },
    },
    watch: {
      'searchForm.selectChannel': {
          handler (to, from) {
              this.getStyleMap()
              this.searchForm.selectType = ''
              this.searchForm.selectLevel = ''
          },
          deep:true,
          immediate:true
          },
      'searchForm.selectType': {
          handler (to, from) {
              this.getLevelMap()
              this.searchForm.selectLevel = ''
          },
          deep:true,
          immediate:true
      },
      regionOrgList(){
        this.regionArr = this.regionOrgList
      }
    },
    created () {
      this.init()
    },
    mounted () {
    },
    methods: {
      init () {
          this.employeeLevel = this.userInfo.employeeLevel
          if(this.isBU){
            let params = {
              buOrgId: this.userInfo.orgDTO.parentOrgId
            }
            this.getRegionList(params)
          }
          else if(this.isRegion) this.$store.dispatch('getThemeRegionList')
          this.getThemeNamelist ()
          this.getBuList()
          this.getSelectChannel()
          this.getSelectBrand()
          this.getThemelist()
      },
      cahngeBu () {
          if (!this.searchForm.buCode) {
              return this.searchForm.regionCode = ''
          }
          if (this.buArr.length > 0) {
              for (const item of this.buArr) {
                  if (item.orgCode == this.searchForm.buCode) {
                      this.searchForm.buOrgId = item.orgId
                      this.searchForm.regionCode = ''
                      if (!this.searchForm.buOrgId) return
                      let params = {
                          buOrgId: this.searchForm.buOrgId
                      }
                      this.getRegionList(params)
                  }
              }
          }
      },
      async getThemeRegionList () {
          let params = {}
          const { data } = await gameplanApi.getThemeRegionList(params);
          if (data.resultCode === "0") {
            this.regionArr = data.resultData.regionList || [];
          }
      },
      async getBuList () {
          let params = {}
          const { data } = await gameplanApi.getBuList(params);
          if (data.resultCode === "0") {
              this.buArr = data.resultData.buList || [];
              this.cahngeBu()
          }
      },
      async getRegionList (params) {
          const { data } = await gameplanApi.getRegionList(params);
          if (data.resultCode === "0") {
              this.regionArr = data.resultData.regionList || [];
          }
      },
      async deletePocinformation(params){
        console.log(params);
        const { data } = await gameplanApi.deletePocinformation(params);
          if (data.resultCode === "0") {
            this.$message.success("删除成功!")
            this.getThemelist()
          }
      },
      gotoReportAgain(item){
          this.$router.push({path:'/gameplan/activity-report-add',query:{'activityId':item.activityId,'themeDetailId':item.themeDetailId,'typeStatus':this.menuCode,'routerType':'reportAgian'}})
      },
      handleDelete(item){
        this.$confirm('是否确认删除该提报？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
        }).then(async() => {
          const gpActivityInfoDTO = {
            activityId:item.activityId
          }
          const params ={
            gpActivityInfoDTO
          }
          this.deletePocinformation(params)
        }).catch(() => { });
      },
      getBluename (name) {
          if (name == 'region') {
              return 'Region'
          } else if (name == 'bu') {
              return 'BU'
          } else if (name == 'hq') {
              return 'HQ'
          } else {
              return 'error'
          }
      },
      getToolsname (item,type,sign) {
          if (type == 'saleName') {
              let arr = item.gpActivityPocDTOList
              if (arr.length > 0) {
                  let name = arr.map((item)=>{
                      return item.pocName
                  }).join(sign)
                  return name
              }
          } else if (type == 'activityName') {
              let arr = []
              if (item.themeName) {
                  arr.push(item.themeName)
              }
              if (item.themeChannelName) {
                  arr.push(item.themeChannelName.split('|')[1])
              }
              if (item.themeStyleName) {
                  arr.push(item.themeStyleName)
              }
              if (item.themeLevelName) {
                  arr.push(item.themeLevelName)
              }
              let name = arr.map((item)=>{
                  return item
              }).join(sign)
              return name
          }
          else if (type == 'areaName') {
              let arr = []
              if (item.regionName) {
                  arr.push(item.regionName.split('|')[0])
              }else {
                  return
              }
              let name = arr.map((item)=>{
                  return item
              }).join(sign)
              return name
          }
          else if (type == 'typeName') {
              let pocRelateType = item.gpThemeDetailDTO.pocRelateType
              if (pocRelateType == '0') {
                  return '无售点'
              }else if (pocRelateType == '1') {
                  return '单售点'
              } else if (pocRelateType == '2') {
                  return '多售点'
              } else {
                  return 'error'
              }
          }
          else {
              return 'error'
          }
      },
      async getStyleMap () {
          let params = {
              channelCode:this.searchForm.selectChannel
          }
          const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
          if (data.resultCode === "0") {
              this.typeOptions = data.resultData.themeStyleMap || {};
          }
      },
      async getLevelMap () {
          let params = {
              styleCode:this.searchForm.selectType
          }
          const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
          if (data.resultCode === "0") {
              this.levelOptions = data.resultData.themeLevelMap || {};
          }
      },
      getTime (timestamp) {
          if (timestamp === 0 || timestamp == null) {
              return ''
          } else {
              var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
              const Y = date.getFullYear() + '-'
              const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
              const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
              // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
              // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
              // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
              return Y + M + D
          }
      },
      getThemeNamelist () {
          let params = {
              buCode:this.searchForm.buCode,
              regionCode:this.searchForm.regionCode,
              activityStatus: this.menuCode,
          }
          gameplanApi.getSubmitnameList(params).then(res=>{
              if (res.data.resultCode === '0') {
                  this.themeList = res.data.resultData.themeNameList || []
              }
          })
      },
      getThemelist () {
          this.loading = true
          let params = {
              page: this.searchForm.page,
              pageSize: this.searchForm.pageSize,
              themeName: this.searchForm.activityName,
              themeChannelCode: this.searchForm.selectChannel,
              themeStyleCode: this.searchForm.selectType,
              themeLevelCode: this.searchForm.selectLevel,
              activityStatus: this.menuCode,
              blockName:this.searchForm.blockName,
              pocName:this.searchForm.pocName,
              themeId: this.searchForm.themeId,
              buCode:this.searchForm.buCode,
              regionCode:this.searchForm.regionCode
          }
          gameplanApi.getGamepalnReportlist(params).then(res=>{
              if (res.data.resultCode === '0') {
                  this.loading = false
                  let pageData = res.data.resultData.pageInfo
                  this.searchForm.page = Number(pageData.curPage)
                  this.searchForm.total = Number(pageData.totalCounts)
                  // this.themeList = res.data.resultData.themeNameList || []
                  if (res.data.resultData.activityList == null) {
                      this.cardData = []
                  } else {
                      this.cardData = res.data.resultData.activityList
                  }
              } else {
                  this.loading = false
                  console.log('接口error');
              }
          })
      },
      async getSelectChannel () {
          // name=gpThemeChannelMap&type=list或map
          let params = {
              name:'gpThemeChannelMap',
              type:'list'
          }
          let data =  await gameplanApi.getGamepalnChannelquery(params)
          this.channelOptions = data.data.resultData.gpThemeChannelMap
      },
      async getSelectBrand () {
          let data =  await gameplanApi.getGamepalnBrandquery()
          this.brandOptions = data.data.resultData.btmpBrandDTOList
      },
      handleCurrentChange (val) {
          this.searchForm.page = val
          this.getThemelist()
      },
      queryForm (val) {
          this.$refs.searchForm.validate((valid) => {
              if (valid) {
                  this.searchForm.page =1
                  this.getThemelist()
              } else {
                  return false;
              }
          });
      },
      resetForm () {
          this.$refs.searchForm.resetFields();
          this.searchForm.page =1
          this.getThemelist()
      },
      // 活动详情
      activityDetail (item) {
          // 'typeStatus':item.activityStatus,
          this.$router.push({path:'/gameplan/activity-report-detail',query:{'activityId':item.activityId,'themeDetailId':item.themeDetailId,'typeStatus':this.menuCode,'routerType':'view'}})
      },
    }
  }
</script>
<style lang="scss" scoped>
.operation_btn_box{
  display: flex;
  .operate_btn{
    text-align: center;
    padding: 5px 12px;
    border-radius: 4px;
    margin: -5px 0  0 10px;
    cursor: pointer;
    line-height:25px;
    height:25px;
    min-width:50px;
  }
  .operate_btn_red {
    color: white;
    background-color: rgb(214, 0, 0);
  }
  .operate_btn_white{
    color: rgb(214, 0, 0);
    background-color: white;
    border: 1px solid rgb(214, 0, 0);
  }
  .btn-left {
              padding: 4px 12px;
              border-radius: 4px;
              border: 1px solid #CD1231;
              background-color: #FFFFFF;
              color: #CD1231;
              cursor: pointer;
          }
          .btn-right {
              padding: 4px 12px;
              border-radius: 4px;
              border: 1px solid #CD1231;
              background-color: #CD1231;
              color: #FFFFFF;
              margin-left: 15px;
              cursor: pointer;
          }
}
  .is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
  }
  .content-wrapper {
    min-height: calc(100vh - 320px) !important;
    font-family: SourceHanSansSC-regular;
    .content-right {
      height: 100%;
      box-sizing: border-box;
      a {
        text-decoration: none;
        color: #000;
      }
      .search {
          .searchForm {
              margin: auto;
              width: 1000px;
              .item {
                  width:120px;
                  ::v-deep .el-input__inner {
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                  }
              }
              .item-btn {
                  //margin-left: 30px;
              }
              .selcetItem{
                  ::v-deep .el-select-dropdown__wrap {
                      max-height: 274px;
                      max-width: 200px;
                  }
              }
          }
      }
      .card-box {
          .card {
              margin: auto;
              width: 980px;
              display: flex;
              justify-content: space-between;
              padding:10px 10px;
              background-color: #FFFFFF ;
              border-radius: 8px;
              font-size: 14px;
              margin-bottom: 20px;
              .left {
                  text-align: left;
                  color: #101010;
                  width: 70%;
                  .left-top {
                      // line-height: 27px;
                      // font-size: 18px;
                      // font-weight: 600;
                      // word-wrap: break-word;
                      // word-break: normal;
                      // word-break: break-all;
                      padding-bottom: 10px;
                      font-size: 18px;
                      display: flex;
                      .top-name {
                          font-weight: 600;
                          word-wrap: break-word;
                          word-break: normal;
                          word-break: break-all;
                      }
                      .top-sign {
                          color: #FFFFFF;
                          background-color: #40A5EE;
                          margin-left: 10px;
                          padding: 0px 8px;
                          line-height: 18px;
                          height: 18px;
                          font-size: 14px;
                          margin-top: 2px;
                          font-weight: 600;
                      }
                  }
                  .left-second {
                      display: flex;
                      padding-bottom: 10px;
                      .second-left {
                          margin-right: 25px;
                          line-height: 20px;
                          word-wrap: break-word;
                          word-break: normal;
                          word-break: break-all;
                      }
                      .second-right {
                          flex: 1;
                          min-width: 100px;
                          line-height: 20px;
                      }
                  }
                  .left-third {
                      line-height: 20px;
                      padding-bottom: 10px;
                  }
                  .left-last {
                      line-height: 20px;
                      padding-bottom: 10px;
                  }
              }
              .right {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: flex-end;
                  .right-top {
                      line-height: 27px;
                      color: #CD1231 ;
                      font-size: 16px;
                      font-weight: 600;
                  }
              }
          }
      }
      .pagination {
          position: relative;
          bottom: 0;
          text-align: center;
      }
    }
  }
</style>
